const linkList = [
    { label: "Name", name: "name", widget: "string", required: false, i18n: true },
    { label: "Link", name: "link", widget: "string", required: false },
    { label: "Active", name: "active", widget: "boolean", default: true, required: false, i18n: true },
    {
        label: "Page",
        name: "page",
        widget: "relation",
        multiple: false,
        required: false,
        collection: "pages",
        search_fields: [ "title" ],
        value_field: "title",
        display_fields: [ "title" ]
    }
]

const navigation = [
    ...linkList,
    {
        label: "Navigation Sub",
        name: "items",
        widget: "list",
        i18n: true,
        fields: [
            ...linkList
        ]
    }
]


const settings = {
    label: "Theme Settings",
    name: "theme",
    file: "site/data/theme.yaml",
    i18n: true,
    fields: [
        { name: "logo", label: "Logo", widget: "image",  required: false, i18n: true},
        { name: "logo_alt", label: "Logo Alt", widget: "image",  required: false, i18n: true},
        {name: "logo_footer", label: "Logo Footer", widget: "image", required: false, i18n: true},
        /*
        {
            label: "Theme",
            name: "theme",
            widget: "select",
            options: [
                "playmob",
                "rokit",
                "light",
                "dark",
                "cupcake",
                "bumblebee",
                "emerald",
                "corporate",
                "synthwave",
                "retro",
                "cyberpunk",
                "valentine",
                "halloween",
                "garden",
                "forest",
                "aqua",
                "lofi",
                "pastel",
                "fantasy",
                "wireframe",
                "black",
                "luxury",
                "dracula",
                "cmyk"
            ],
            default: 'rokit'
        },
         */
        {
            label: "Favicon",
            name: "favicon",
            widget: "image",
            media_folder: "/site/assets/images/favicon/",
            public_folder: "/images/favicon/",
            i18n: true,
            required: false
        },
        {
            label: "Placeholder image",
            name: "placeholder_img",
            media_folder: "/site/assets/images/placeholder/",
            public_folder: "/images/placeholder/",
            widget: "image",
            i18n: true,
            required: false
        },
        {
            label: "Job Section Image",
            name: "job_img",
            media_folder: "/site/assets/images/placeholder/",
            public_folder: "/images/placeholder/",
            widget: "image",
            i18n: true,
            required: false
        },
        {
            label: "Share default Image",
            name: "share_img",
            media_folder: "/site/assets/images/",
            public_folder: "/images/",
            widget: "image",
            i18n: true,
            required: false
        },
        {
            label: "Navigation",
            name: "cms_navbar",
            widget: "boolean",
            i18n: true,
            default: false
        },
        {
            label: "Search",
            name: "search",
            widget: "boolean",
            i18n: true,
            default: false
        },
        {
            label: "Activate Menu List",
            name: "active",
            widget: "boolean",
            i18n: true,
            default: false
        },
        {
            label: "Navigation Main",
            name: "items",
            widget: "list",
            i18n: true,
            fields: [...navigation]
        },
        {
            label: "Footer Mission Statement",
            name: "footer_statement",
            widget: "markdown",
            i18n: true,
            required: false
        },
        {
            label: "Navigation Footer",
            name: "footer_sections",
            widget: "list",
            i18n: true,
            fields: [
                { label: "Section", name: "section", widget: "string", required: false },
                { label: "Link", name: "link", widget: "string", required: false },
                { label: "Active", name: "active", widget: "boolean", default: true, required: false },
                {
                    label: "Page",
                    name: "page",
                    widget: "relation",
                    multiple: false,
                    required: false,
                    collection: "pages",
                    search_fields: [ "title" ],
                    value_field: "title",
                    display_fields: [ "title" ]
                },
                {
                    label: "Footer Navigation Section",
                    name: "footer_section_links",
                    widget: "list",
                    fields: [...linkList]
                }
            ]
        },
        {
            label: "Navigation Legal",
            name: "footer_legals",
            i18n: true,
            widget: "list",
            fields: [
                { label: "Label", name: "label", widget: "string" , i18n: true},
                { label: "Active", name: "active", widget: "boolean", default: true, required: false, i18n: true },
                {
                    label: "Legals",
                    name: "legal",
                    widget: "relation",
                    multiple: false,
                    required: false,
                    collection: "legals",
                    search_fields: [ "title" ],
                    value_field: "{{slug}}",
                    display_fields: [ "title" ],
                    i18n: true
                },
                { label: "Link", name: "link", widget: "string", required: false, hint: "Optional Link for external resources",
                    i18n: true },
            ]
        },
        {
            label: "Legal",
            name: "legal",
            widget: "markdown",
            i18n: true
        }
    ]
}

export default settings;
